var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('ul',[_c('li',[_vm._v("关于我们")]),_c('li',[_vm._v("法律声明")]),_c('li',[_vm._v("隐私政策")]),_c('li',[_vm._v("廉政举报")]),_c('li',[_vm._v("联系我们")]),_c('li',[_vm._v("加入我们")])]),_c('p',[_vm._v("© 2009-2019 smartai.com 版权所有 ICP证：45456566")]),_c('p',[_vm._v("公网安备 436435455号")])])
}]

export { render, staticRenderFns }